import React, { Component } from 'react';
import classNames from 'classnames';
import styles from '@src/slide/application/service/snap-line-service/render/components/arrow-line/double-arrow-line.less';
import { Orient } from '@src/slide/application/service/snap-line-service/interface/orient.interface';
import type { IRect } from '@src/slide/infrastructure/module/independent/graphic/rect/rect';
import { IBaseUIProps } from '@src/slide/application/service/snap-line-service/interface/render.interface';

export interface DoubleArrowLineProps extends IBaseUIProps {
    color?: string;
    arrowSize: Pick<IRect, 'width' | 'height'>;
    lineRect: IRect;
    orient: Orient;
}
export class DoubleArrowLine extends Component<DoubleArrowLineProps> {
    public static defaultProps = {
        color: '#d08a7c',
    };

    public render() {
        const { width: arrowOriginWidth, height: arrowOriginHeight } = this.props.arrowSize;
        const { top, left, height, width } = this.props.lineRect;
        const { scale, strokeDash: originStrokeDash } = this.props;
        const isHorizontal = this.props.orient === Orient.HORIZONTAL;
        const arrowWidth = arrowOriginWidth / scale.graphicScale;
        const arrowHeight = arrowOriginHeight / scale.graphicScale;
        const strokeDash = originStrokeDash / scale.graphicScale;
        const style = {
            top,
            left,
            width: isHorizontal ? width * scale.frameScale : arrowWidth,
            height: isHorizontal ? arrowWidth : height * scale.frameScale,
        };

        const svgLinePosition = isHorizontal ? {
            x1: 0,
            y1: arrowWidth / 2,
            x2: width * scale.frameScale,
            y2: arrowWidth / 2,
        } : {
            x1: arrowWidth / 2,
            y1: 0,
            x2: arrowWidth / 2,
            y2: height * scale.frameScale,
        };

        const displayStyle = {
            top: style.top * scale.frameScale,
            left: style.left * scale.frameScale,
            width: style.width,
            height: style.height,
        };


        const arrowPadding = arrowWidth;
        const startArrowPoints = isHorizontal ? {
            x1: svgLinePosition.x1,
            y1: svgLinePosition.y1,
            x2: svgLinePosition.x1 + arrowPadding,
            y2: svgLinePosition.y1,
        } : {
            x1: svgLinePosition.x1,
            y1: svgLinePosition.y1,
            x2: svgLinePosition.x1,
            y2: svgLinePosition.y1 + arrowPadding,
        };
        const endsArrowPoints = isHorizontal ? {
            x1: svgLinePosition.x2 - arrowPadding,
            y1: svgLinePosition.y2,
            x2: svgLinePosition.x2,
            y2: svgLinePosition.y2,
        } : {
            x1: svgLinePosition.x2,
            y1: svgLinePosition.y2 - arrowPadding,
            x2: svgLinePosition.x2,
            y2: svgLinePosition.y2,
        };
        const centerLinePoints = {
            x1: startArrowPoints.x2,
            y1: startArrowPoints.y2,
            x2: endsArrowPoints.x1,
            y2: endsArrowPoints.y1,
        };

        const strokeWidth = this.props.orient === Orient.HORIZONTAL ? height : width;

        return <svg
            style={displayStyle}
            className={classNames({
                [styles['snap-line-double-arrow-line']]: true,
            })}
            xmlns="http://www.w3.org/2000/svg">
            <defs>
                <marker
                    id="arrowhead-start"
                    markerWidth={arrowWidth}
                    markerHeight={arrowHeight}
                    refX="1"
                    refY={arrowHeight / 2}
                    orient="auto"
                >
                    <polygon fill={this.props.color} points={`${arrowWidth} 0, 0 ${arrowHeight / 2}, ${arrowWidth} ${arrowHeight}`}/>
                </marker>
                <marker
                    id="arrowhead-end"
                    markerWidth={arrowWidth}
                    markerHeight={arrowHeight}
                    refX={arrowWidth}
                    refY={arrowHeight / 2}
                    orient="auto"
                >
                    <polygon fill={this.props.color} points={`0 0, ${arrowWidth} ${arrowHeight / 2}, 0 ${arrowHeight}`}/>
                </marker>
            </defs>
            <polyline
                points={`${startArrowPoints.x1} ${startArrowPoints.y1} ${startArrowPoints.x2} ${startArrowPoints.y2}`}
                stroke={this.props.color}
                strokeWidth={1}
                fill="none"
                strokeDasharray={`${strokeDash}, ${strokeDash}`}
                markerStart="url(#arrowhead-start)"
            />
            <polyline
                points={`${centerLinePoints.x1} ${centerLinePoints.y1} ${centerLinePoints.x2} ${centerLinePoints.y2}`}
                stroke={this.props.color}
                strokeWidth={strokeWidth / scale.graphicScale}
                fill="none"
                strokeDasharray={`${strokeDash}, ${strokeDash}`}
            />
            <polyline
                points={`${endsArrowPoints.x1} ${endsArrowPoints.y1} ${endsArrowPoints.x2} ${endsArrowPoints.y2}`}
                stroke={this.props.color}
                strokeWidth={1}
                fill="none"
                strokeDasharray={`${strokeDash}, ${strokeDash}`}
                markerEnd="url(#arrowhead-end)"
            />
        </svg>;
    }
}
